// Use when links should be set as normal <a> elements, rather than Next's <Link> elements
// Next links become problematic when linking to acquiition or OAC

export default function checkForExternalLink(link) {
  
	var externalLinkRegexList = ['(?:www\.netspend\.com)?/account[/?#]', '(?:www\.netspend\.com)?/get-a-prepaid-card[/?#]', '(?:www\.netspend\.com)?/sign-up[/?#]', '(?:www\.netspend\.com)?/business[/?#]', 'itunes.apple.com/us/app', 'apps.apple.com/us/app', 'play.google.com/store/apps', 'afss=true', 'netspendwallet.onelink.me', 'app.netspend.com'].join('|');
	const regex = new RegExp(String.raw`(${externalLinkRegexList})`, 'gi');

	//if link is unset or is '#', return as an external tag
	if (!link || link === '#') return true;

	//if the link starts with any of the regex strings, return as external a tag
	if (link.match(regex)?.length > 0) {
		return true;
	}
	return false;
}